import colors from 'vuetify/lib/util/colors'

export default {
	primary: "#b00c0e",
	secondary: "#f1861b",
	tertiary: '#fff',
	accent: "#b00c0e",
	error: "#8f00ff", // default #bc2025
	// error: "#e61c1c",
	info: '#2196F3',
	success: '#4CAF50',
	warning: '#FFC107',
}